// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--breakpoints-xs: 1100px;
	--breakpoint-s: 1300px;
	--breakpoint-l: 1500px;
	--breakpoint-xl: 2000px;
	--breakpoint-xxl: 2250px;
	--breakpoint-xxxl: 2500px;
}`, "",{"version":3,"sources":["webpack://./src/Theme/Breakpoints/breakpoint.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;CACxB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,wBAAwB;CACxB,yBAAyB;AAC1B","sourcesContent":[":root {\r\n\t--breakpoints-xs: 1100px;\r\n\t--breakpoint-s: 1300px;\r\n\t--breakpoint-l: 1500px;\r\n\t--breakpoint-xl: 2000px;\r\n\t--breakpoint-xxl: 2250px;\r\n\t--breakpoint-xxxl: 2500px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
